<div class="grid mt-1">
  <div class="flex ml-3 mb-2 gap-2">
    <i class="pi pi-info-circle" style="font-size: 1.2rem"></i>
    <p class="text-base font-semibold">
      {{ message }}
      <i *ngIf="moduleType?.toLowerCase() === 'meeting'" class="{{ message.toLowerCase().includes('decline') ? 'pi pi-times' : 'pi pi-check' }}"></i>
    </p>
  </div>
  <div *ngIf="moduleType?.toLowerCase() === 'meeting' && data" class="col-12">
    <div class="flex gap-5 mt-2">
      <i class="mt-1 pi pi-user" style="font-size: 1.3rem"></i>
      <p class="font-semibold text-sm">{{ data.createdBy?.fullname }}</p>
    </div>
    <div class="flex gap-5 mt-2">
      <i class="mt-1 pi pi-bookmark-fill" style="font-size: 1.3rem"></i>
      <p class="font-semibold text-sm">{{ data.title }}</p>
    </div>
    <div class="flex gap-5 mt-2">
      <i class="mt-1 pi pi-calendar" style="font-size: 1.3rem"></i>
      <div>
        <p class="font-semibold text-sm">{{ data.startDate }} - {{ data.endDate }}</p>
        <p *ngIf="data.allDay">{{ data.allDay }}</p>
      </div>
    </div>
    <div class="flex gap-5 mt-2">
      <i class="mt-1 pi pi-caret-down" style="font-size: 1.3rem"></i>
      <div>
        <p class="font-semibold text-sm">Physical, {{ data.location }}</p>
        <p class="font-semibold text-sm" *ngIf="data.isOnline">
          {{ data.isOnline && 'Online,' }}
          <a href="{{ data.link }}" target="_blank">{{ data.link }}</a>
        </p>
      </div>
    </div>
    <div class="flex gap-5 mt-2">
      <i class="mt-1 pi pi-users" style="font-size: 1.3rem"></i>
      <div class="flex flex-wrap gap-2">
        <div *ngFor="let participant of data.participants">
          <!-- <p-tag [style]="{'width': '10px'}">
                        <app-avatar-generator [name]="participant?.participantId?.fullname"></app-avatar-generator>
                        <p class="mt-3">{{participant?.participantId?.fullname + ' - '}}</p>
                        <p class="ml-3">{{participant?.status}}</p>
                    </p-tag> -->
          <p-chip class="my-chip-gray">
            <app-avatar-generator [name]="participant?.participantId?.fullname"></app-avatar-generator>
            <p class="mt-3 text-sm">
              {{ participant?.participantId?.fullname + ' - ' }}
            </p>
            <p class="ml-3 text-sm">{{ participant?.status }}</p>
          </p-chip>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex justify-content-end mt-4">
  <button pButton icon="pi pi-times" label="No" (click)="confirmationResponse(false)" class="p-button-text mb-2"></button>
  <button pButton icon="pi pi-check" label="Yes" (click)="confirmationResponse(true)" class="p-button-primary mb-2"></button>
</div>
